import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTidalComponent } from './simple-icons-tidal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTidalComponent ],
    exports:      [ SimpleIconsTidalComponent ],
    bootstrap:    []
})
export class SimpleIconsTidalModule {}
